// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./common/Navbar";
// import Sidebar from "./common/Sidebar";
// import Footer from "./common/Footer";
// import "./TimesheetList.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const TimesheetList = () => {
//   const navigate = useNavigate();
//   const [timesheets, setTimesheets] = useState([]);
//   const [error, setError] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedTimesheet, setSelectedTimesheet] = useState(null);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formData, setFormData] = useState({ taskName: "", duration: "" });
//   const [formErrors, setFormErrors] = useState({ taskName: "", duration: "" });
//   const [isSaving, setIsSaving] = useState(false);
//   const [showDeleteDialog, setShowDeleteDialog] = useState(false);
//   const [taskToDelete, setTaskToDelete] = useState({
//     timesheetId: null,
//     taskId: null,
//   });
//   const [successMessage, setSuccessMessage] = useState("");
//   const [timeRange, setTimeRange] = useState("This Week");
//   const [searchQuery, setSearchQuery] = useState("");

//   // Pagination state
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 5,
//     total: 0,
//     pages: 1,
//   });

//   useEffect(() => {
//     const fetchTimesheets = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("No token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.msg || "Error fetching timesheets");
//         }

//         const data = await response.json();
//         // Ensure timesheets is always an array
//         setTimesheets(Array.isArray(data.timesheets) ? data.timesheets : []);
//         setPagination({
//           ...pagination,
//           total: data.total || 0,
//           pages: data.pages || 1,
//         });
//         setError("");
//       } catch (err) {
//         console.error("Error fetching timesheets:", err);
//         setError(err.message || "Error fetching timesheets");
//         setTimesheets([]); // Set to empty array on error
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTimesheets();
//   }, [pagination.page]);

//   // Sort timesheets by date in descending order (newest first)
//   const sortedTimesheets = (Array.isArray(timesheets) ? [...timesheets] : [])
//     .sort((a, b) => new Date(b.date) - new Date(a.date))
//     .filter(
//       (timesheet) =>
//         timesheet.taskDetails &&
//         Array.isArray(timesheet.taskDetails) &&
//         timesheet.taskDetails.some(
//           (task) =>
//             task.taskName &&
//             task.taskName.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//     );

//   // Group timesheets by month/year for better organization
//   const groupedTimesheets = sortedTimesheets.reduce((acc, timesheet) => {
//     const date = new Date(timesheet.date);
//     const monthYear = date.toLocaleDateString("en-US", {
//       month: "long",
//       year: "numeric",
//     });

//     if (!acc[monthYear]) {
//       acc[monthYear] = [];
//     }
//     acc[monthYear].push(timesheet);
//     return acc;
//   }, {});

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const formatDay = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       weekday: "short",
//     });
//   };

//   const handleUpdateClick = (timesheet, task) => {
//     setSelectedTimesheet(timesheet);
//     setSelectedTask(task);
//     setFormData({ taskName: task.taskName, duration: task.duration });
//     setFormErrors({ taskName: "", duration: "" });
//     setShowModal(true);
//   };

//   const handleDeleteClick = (timesheetId, taskId) => {
//     setTaskToDelete({ timesheetId, taskId });
//     setShowDeleteDialog(true);
//   };

//   const validateForm = () => {
//     let valid = true;
//     const newErrors = { taskName: "", duration: "" };

//     if (!formData.taskName.trim()) {
//       newErrors.taskName = "Task name is required";
//       valid = false;
//     }

//     if (!formData.duration) {
//       newErrors.duration = "Duration is required";
//       valid = false;
//     } else if (parseFloat(formData.duration) <= 0) {
//       newErrors.duration = "Duration must be greater than 0";
//       valid = false;
//     }

//     setFormErrors(newErrors);
//     return valid;
//   };

//   const confirmDelete = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const response = await fetch(
//         `${BASE_URL}/api/timesheet/delete/${taskToDelete.timesheetId}/task/${taskToDelete.taskId}`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.msg || "Error deleting task");
//       }

//       // Refetch timesheets after deletion to update pagination
//       const fetchResponse = await fetch(
//         `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!fetchResponse.ok) {
//         const errorData = await fetchResponse.json();
//         throw new Error(errorData.msg || "Error fetching updated timesheets");
//       }

//       const data = await fetchResponse.json();
//       setTimesheets(data.timesheets);
//       setPagination({
//         ...pagination,
//         total: data.total,
//         pages: data.pages,
//       });

//       setSuccessMessage("Task deleted successfully!");
//       setTimeout(() => setSuccessMessage(""), 3000);
//     } catch (err) {
//       console.error("Error deleting task:", err);
//       setError(err.message || "Error deleting task");
//     } finally {
//       setShowDeleteDialog(false);
//       setTaskToDelete({ timesheetId: null, taskId: null });
//     }
//   };

//   const handleSaveChanges = async () => {
//     if (!selectedTimesheet || !selectedTask) return;

//     if (!validateForm()) {
//       return;
//     }

//     try {
//       setIsSaving(true);
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const response = await fetch(
//         `${BASE_URL}/api/timesheet/${selectedTimesheet._id}/tasks/${selectedTask._id}`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.msg || "Error updating task");
//       }

//       // Refetch timesheets after update
//       const fetchResponse = await fetch(
//         `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!fetchResponse.ok) {
//         const errorData = await fetchResponse.json();
//         throw new Error(errorData.msg || "Error fetching updated timesheets");
//       }

//       const data = await fetchResponse.json();
//       setTimesheets(data.timesheets);

//       setSuccessMessage("Task updated successfully!");
//       setTimeout(() => setSuccessMessage(""), 3000);

//       setShowModal(false);
//       setSelectedTimesheet(null);
//       setSelectedTask(null);
//     } catch (err) {
//       console.error("Error updating task:", err);
//       setError(err.message || "Error updating task");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const getTotalHours = () => {
//     return sortedTimesheets
//       .reduce((total, timesheet) => {
//         return total + (parseFloat(timesheet.hoursWorked) || 0);
//       }, 0)
//       .toFixed(1);
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= pagination.pages) {
//       setPagination({ ...pagination, page: newPage });
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen bg-gradient-to-br from-indigo-50 to-white">
//         <div className="flex flex-col items-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
//           <p className="mt-4 text-indigo-700 font-medium">
//             Loading your timesheets...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gradient-to-br from-indigo-50 to-white min-h-screen">
//       <Navbar />
//       <div className="flex">
//         <Sidebar />

//         <div className="flex-1 overflow-auto">
//           <div className="container mx-auto px-4 py-8 max-w-7xl">
//             {/* Notification Messages */}
//             {successMessage && (
//               <div className="fixed top-20 right-4 z-50 animate-fade-in">
//                 <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 rounded-lg shadow-lg flex items-center">
//                   <svg
//                     className="w-5 h-5 mr-2"
//                     fill="currentColor"
//                     viewBox="0 0 20 20"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                   <span>{successMessage}</span>
//                 </div>
//               </div>
//             )}

//             {error && (
//               <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded-lg">
//                 <div className="flex items-center">
//                   <svg
//                     className="w-5 h-5 mr-2"
//                     fill="currentColor"
//                     viewBox="0 0 20 20"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                   <span>{error}</span>
//                 </div>
//               </div>
//             )}

//             {/* Header Section */}
//             <div className="mb-8">
//               <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
//                 <div>
//                   <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
//                     Timesheets
//                   </h1>
//                   <p className="text-gray-600 mt-2">
//                     Track and manage your work hours
//                   </p>
//                 </div>
//                 <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
//                   <div className="relative flex-grow">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="Search tasks..."
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                   </div>
//                   <select
//                     className="block w-full md:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
//                     value={timeRange}
//                     onChange={(e) => setTimeRange(e.target.value)}
//                   >
//                     <option>This Week</option>
//                     <option>Last Week</option>
//                     <option>This Month</option>
//                     <option>Last Month</option>
//                     <option>All Time</option>
//                   </select>
//                   <button
//                     onClick={() => navigate("/timesheet")}
//                     className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg shadow-md flex items-center justify-center transition duration-300 whitespace-nowrap"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                       />
//                     </svg>
//                     Add Entry
//                   </button>
//                 </div>
//               </div>

//               {/* Summary Cards */}
//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-indigo-100 text-indigo-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Days</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {pagination.total}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-green-100 text-green-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Hours</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {getTotalHours()}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-purple-100 text-purple-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Tasks</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {timesheets.reduce(
//                           (total, ts) => total + ts.taskDetails.length,
//                           0
//                         )}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Timesheets List */}
//             {timesheets.length === 0 ? (
//               <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-100">
//                 <div className="inline-block bg-indigo-100 p-6 rounded-full mb-4">
//                   <svg
//                     className="w-12 h-12 text-indigo-600"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                 </div>
//                 <h3 className="text-xl font-medium text-gray-700">
//                   No timesheets found
//                 </h3>
//                 <p className="text-gray-500 mt-2 mb-6">
//                   {searchQuery
//                     ? "No tasks match your search criteria"
//                     : "Add your first timesheet entry to get started"}
//                 </p>
//                 <button
//                   onClick={() => navigate("/timesheet")}
//                   className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg shadow-md flex items-center mx-auto"
//                 >
//                   <svg
//                     className="w-4 h-4 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                     />
//                   </svg>
//                   Add Entry
//                 </button>
//               </div>
//             ) : (
//               <div className="space-y-8">
//                 {Object.entries(groupedTimesheets).map(
//                   ([monthYear, monthTimesheets]) => (
//                     <div
//                       key={monthYear}
//                       className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
//                     >
//                       <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
//                         <h2 className="text-lg font-semibold text-gray-800">
//                           {monthYear}
//                         </h2>
//                       </div>
//                       <div className="divide-y divide-gray-100">
//                         {monthTimesheets.map((timesheet) => (
//                           <div key={timesheet._id} className="p-6">
//                             <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
//                               <div className="flex items-center mb-3 sm:mb-0">
//                                 <div className="bg-indigo-100 p-2 rounded-lg mr-3">
//                                   <span className="text-indigo-600 font-medium">
//                                     {formatDay(timesheet.date)}
//                                   </span>
//                                 </div>
//                                 <div>
//                                   <h3 className="font-medium text-gray-800">
//                                     {formatDate(timesheet.date)}
//                                   </h3>
//                                 </div>
//                               </div>
//                               <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
//                                 <svg
//                                   className="w-4 h-4 inline mr-1"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                   />
//                                 </svg>
//                                 {timesheet.hoursWorked} hours
//                               </div>
//                             </div>

//                             <div className="space-y-3">
//                               {timesheet.taskDetails.map((task) => (
//                                 <div
//                                   key={task._id}
//                                   className="bg-gray-50 p-4 rounded-lg"
//                                 >
//                                   <div className="flex justify-between items-start">
//                                     <div className="flex-grow">
//                                       <h4 className="font-medium text-gray-800 flex items-center">
//                                         <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
//                                         {task.taskName}
//                                       </h4>
//                                       <div className="flex items-center mt-2 text-sm text-gray-500">
//                                         <svg
//                                           className="w-4 h-4 mr-1"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                           />
//                                         </svg>
//                                         <span>{task.duration} hours</span>
//                                       </div>
//                                     </div>
//                                     <div className="flex space-x-2 ml-4">
//                                       <button
//                                         onClick={() =>
//                                           handleUpdateClick(timesheet, task)
//                                         }
//                                         className="text-indigo-600 hover:text-indigo-800 p-1 rounded-full transition"
//                                         title="Edit task"
//                                       >
//                                         <svg
//                                           className="w-5 h-5"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                                           />
//                                         </svg>
//                                       </button>
//                                       <button
//                                         onClick={() =>
//                                           handleDeleteClick(
//                                             timesheet._id,
//                                             task._id
//                                           )
//                                         }
//                                         className="text-red-600 hover:text-red-800 p-1 rounded-full transition"
//                                         title="Delete task"
//                                       >
//                                         <svg
//                                           className="w-5 h-5"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                           />
//                                         </svg>
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )
//                 )}

//                 {/* Pagination Controls */}
//                 <div className="flex justify-center mt-8">
//                   <nav
//                     className="inline-flex rounded-md shadow-sm -space-x-px"
//                     aria-label="Pagination"
//                   >
//                     <button
//                       onClick={() => handlePageChange(pagination.page - 1)}
//                       disabled={pagination.page === 1}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
//                         pagination.page === 1
//                           ? "text-gray-300 cursor-not-allowed"
//                           : "text-gray-500 hover:bg-gray-50"
//                       }`}
//                     >
//                       <span className="sr-only">Previous</span>
//                       <svg
//                         className="h-5 w-5"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                         aria-hidden="true"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </button>

//                     {/* Page numbers */}
//                     {Array.from(
//                       { length: pagination.pages },
//                       (_, i) => i + 1
//                     ).map((pageNum) => (
//                       <button
//                         key={pageNum}
//                         onClick={() => handlePageChange(pageNum)}
//                         className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
//                           pageNum === pagination.page
//                             ? "bg-indigo-600 text-white border-indigo-600"
//                             : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//                         }`}
//                       >
//                         {pageNum}
//                       </button>
//                     ))}

//                     <button
//                       onClick={() => handlePageChange(pagination.page + 1)}
//                       disabled={pagination.page === pagination.pages}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
//                         pagination.page === pagination.pages
//                           ? "text-gray-300 cursor-not-allowed"
//                           : "text-gray-500 hover:bg-gray-50"
//                       }`}
//                     >
//                       <span className="sr-only">Next</span>
//                       <svg
//                         className="h-5 w-5"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                         aria-hidden="true"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </button>
//                   </nav>
//                 </div>

//                 {/* Page info */}
//                 <div className="text-center text-sm text-gray-500 mt-2">
//                   Showing page {pagination.page} of {pagination.pages} • Total{" "}
//                   {pagination.total} timesheets
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Edit Task Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-xl shadow-xl max-w-md w-full transform transition-all duration-300 ease-in-out">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">Update Task</h3>
//                 <button
//                   onClick={() => setShowModal(false)}
//                   className="text-gray-400 hover:text-gray-500 transition"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Task Name
//                   </label>
//                   <input
//                     type="text"
//                     value={formData.taskName}
//                     onChange={(e) => {
//                       setFormData({ ...formData, taskName: e.target.value });
//                       if (formErrors.taskName) {
//                         setFormErrors({ ...formErrors, taskName: "" });
//                       }
//                     }}
//                     className={`w-full px-3 py-2 border ${
//                       formErrors.taskName ? "border-red-500" : "border-gray-300"
//                     } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500`}
//                   />
//                   {formErrors.taskName && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {formErrors.taskName}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Duration (hours)
//                   </label>
//                   <input
//                     type="number"
//                     value={formData.duration}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
//                         setFormData({ ...formData, duration: value });
//                         if (formErrors.duration) {
//                           setFormErrors({ ...formErrors, duration: "" });
//                         }
//                       }
//                     }}
//                     min="0"
//                     step="0.01"
//                     className={`w-full px-3 py-2 border ${
//                       formErrors.duration ? "border-red-500" : "border-gray-300"
//                     } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500`}
//                   />
//                   {formErrors.duration && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {formErrors.duration}
//                     </p>
//                   )}
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     onClick={() => setShowModal(false)}
//                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     onClick={handleSaveChanges}
//                     disabled={isSaving}
//                     className={`px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition flex items-center ${
//                       isSaving ? "opacity-70 cursor-not-allowed" : ""
//                     }`}
//                   >
//                     {isSaving ? (
//                       <>
//                         <svg
//                           className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                         Saving...
//                       </>
//                     ) : (
//                       <>
//                         <svg
//                           className="w-4 h-4 mr-2"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
//                           />
//                         </svg>
//                         Save Changes
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Dialog */}
//       {showDeleteDialog && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-xl shadow-xl max-w-md w-full transform transition-all duration-300 ease-in-out">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">
//                   Confirm Delete
//                 </h3>
//                 <button
//                   onClick={() => setShowDeleteDialog(false)}
//                   className="text-gray-400 hover:text-gray-500 transition"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <p className="text-gray-700">
//                   Are you sure you want to delete this task? This action cannot
//                   be undone.
//                 </p>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     onClick={() => setShowDeleteDialog(false)}
//                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     onClick={confirmDelete}
//                     className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition flex items-center"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                       />
//                     </svg>
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </div>
//   );
// };

// export default TimesheetList;



























// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./common/Navbar";
// import Sidebar from "./common/Sidebar";
// import Footer from "./common/Footer";
// import "./TimesheetList.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const TimesheetList = () => {
//   const navigate = useNavigate();
//   const [timesheets, setTimesheets] = useState([]);
//   const [error, setError] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedTimesheet, setSelectedTimesheet] = useState(null);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formData, setFormData] = useState({ taskName: "", duration: "" });
//   const [formErrors, setFormErrors] = useState({ taskName: "", duration: "" });
//   const [isSaving, setIsSaving] = useState(false);
//   const [showDeleteDialog, setShowDeleteDialog] = useState(false);
//   const [taskToDelete, setTaskToDelete] = useState({
//     timesheetId: null,
//     taskId: null,
//   });
//   const [successMessage, setSuccessMessage] = useState("");
//   const [timeRange, setTimeRange] = useState("This Week");
//   const [searchQuery, setSearchQuery] = useState("");

//   // Pagination state
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 5,
//     total: 0,
//     pages: 1,
//   });

//   useEffect(() => {
//     const fetchTimesheets = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("No token found. Please log in.");
//           return;
//         }

//         const response = await fetch(
//           `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.msg || "Error fetching timesheets");
//         }

//         const data = await response.json();
//         // Ensure timesheets is always an array
//         setTimesheets(Array.isArray(data.timesheets) ? data.timesheets : []);
//         setPagination({
//           ...pagination,
//           total: data.total || 0,
//           pages: data.pages || 1,
//         });
//         setError("");
//       } catch (err) {
//         console.error("Error fetching timesheets:", err);
//         setError(err.message || "Error fetching timesheets");
//         setTimesheets([]); // Set to empty array on error
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTimesheets();
//   }, [pagination.page]);

//   // Sort timesheets by date in descending order (newest first)
//   const sortedTimesheets = (Array.isArray(timesheets) ? [...timesheets] : [])
//     .sort((a, b) => new Date(b.date) - new Date(a.date))
//     .filter(
//       (timesheet) =>
//         timesheet.taskDetails &&
//         Array.isArray(timesheet.taskDetails) &&
//         timesheet.taskDetails.some(
//           (task) =>
//             task.taskName &&
//             task.taskName.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//     );

//   // Group timesheets by month/year for better organization
//   const groupedTimesheets = sortedTimesheets.reduce((acc, timesheet) => {
//     const date = new Date(timesheet.date);
//     const monthYear = date.toLocaleDateString("en-US", {
//       month: "long",
//       year: "numeric",
//     });

//     if (!acc[monthYear]) {
//       acc[monthYear] = [];
//     }
//     acc[monthYear].push(timesheet);
//     return acc;
//   }, {});

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const formatDay = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       weekday: "short",
//     });
//   };

//   const handleUpdateClick = (timesheet, task) => {
//     setSelectedTimesheet(timesheet);
//     setSelectedTask(task);
//     setFormData({ taskName: task.taskName, duration: task.duration });
//     setFormErrors({ taskName: "", duration: "" });
//     setShowModal(true);
//   };

//   const handleDeleteClick = (timesheetId, taskId) => {
//     setTaskToDelete({ timesheetId, taskId });
//     setShowDeleteDialog(true);
//   };

//   const validateForm = () => {
//     let valid = true;
//     const newErrors = { taskName: "", duration: "" };

//     if (!formData.taskName.trim()) {
//       newErrors.taskName = "Task name is required";
//       valid = false;
//     }

//     if (!formData.duration) {
//       newErrors.duration = "Duration is required";
//       valid = false;
//     } else if (parseFloat(formData.duration) <= 0) {
//       newErrors.duration = "Duration must be greater than 0";
//       valid = false;
//     }

//     setFormErrors(newErrors);
//     return valid;
//   };

//   const confirmDelete = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found. Please log in.");
//         return;
//       }

//       const response = await fetch(
//         `${BASE_URL}/api/timesheet/delete/${taskToDelete.timesheetId}/task/${taskToDelete.taskId}`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.msg || "Error deleting task");
//       }

//       // Refetch timesheets after deletion to update pagination
//       const fetchResponse = await fetch(
//         `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!fetchResponse.ok) {
//         const errorData = await fetchResponse.json();
//         throw new Error(errorData.msg || "Error fetching updated timesheets");
//       }

//       const data = await fetchResponse.json();
//       setTimesheets(data.timesheets);
//       setPagination({
//         ...pagination,
//         total: data.total,
//         pages: data.pages,
//       });

//       setSuccessMessage("Task deleted successfully!");
//       setTimeout(() => setSuccessMessage(""), 3000);
//     } catch (err) {
//       console.error("Error deleting task:", err);
//       setError(err.message || "Error deleting task");
//     } finally {
//       setShowDeleteDialog(false);
//       setTaskToDelete({ timesheetId: null, taskId: null });
//     }
//   };


// const handleSaveChanges = async () => {
//   if (!validateForm()) return;

//   try {
//     setIsSaving(true);
//     const token = sessionStorage.getItem("token");
//     if (!token) {
//       setError("No token found. Please log in.");
//       return;
//     }

//     const response = await fetch(
//       `${BASE_URL}/api/timesheet/${selectedTimesheet._id}/tasks/${selectedTask._id}`,
//       {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       }
//     );

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.msg || "Error updating task");
//     }

//     // Manually update the state
//     setTimesheets(prevTimesheets =>
//       prevTimesheets.map(timesheet => {
//         if (timesheet._id === selectedTimesheet._id) {
//           // Update the specific task
//           const updatedTasks = timesheet.taskDetails.map(task =>
//             task._id === selectedTask._id
//               ? { ...task, ...formData }
//               : task
//           );

//           // Calculate new total hours for this timesheet
//           const newTotalHours = updatedTasks.reduce(
//             (total, task) => total + parseFloat(task.duration || 0),
//             0
//           );

//           return {
//             ...timesheet,
//             taskDetails: updatedTasks,
//             hoursWorked: newTotalHours.toFixed(1) // Update the total hours for the date
//           };
//         }
//         return timesheet;
//       })
//     );

//     setSuccessMessage("Task updated successfully!");
//     setTimeout(() => setSuccessMessage(""), 3000);
//     setShowModal(false);
//   } catch (err) {
//     setError(err.message || "Error updating task");
//   } finally {
//     setIsSaving(false);
//   }
// };

//   const getTotalHours = () => {
//   return sortedTimesheets.reduce((total, timesheet) => {
//     if (!timesheet.taskDetails || !Array.isArray(timesheet.taskDetails)) {
//       return total;
//     }
//     const timesheetHours = timesheet.taskDetails.reduce((sum, task) => {
//       return sum + (parseFloat(task.duration) || 0);
//     }, 0);
//     return total + timesheetHours;
//   }, 0).toFixed(1);
// };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= pagination.pages) {
//       setPagination({ ...pagination, page: newPage });
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen bg-gradient-to-br from-indigo-50 to-white">
//         <div className="flex flex-col items-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
//           <p className="mt-4 text-indigo-700 font-medium">
//             Loading your timesheets...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gradient-to-br from-indigo-50 to-white min-h-screen">
//       <Navbar />
//       <div className="flex">
//         <Sidebar />

//         <div className="flex-1 overflow-auto">
//           <div className="container mx-auto px-4 py-8 max-w-7xl">
//             {/* Notification Messages */}
//             {successMessage && (
//               <div className="fixed top-20 right-4 z-50 animate-fade-in">
//                 <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 rounded-lg shadow-lg flex items-center">
//                   <svg
//                     className="w-5 h-5 mr-2"
//                     fill="currentColor"
//                     viewBox="0 0 20 20"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                   <span>{successMessage}</span>
//                 </div>
//               </div>
//             )}

//             {error && (
//               <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded-lg">
//                 <div className="flex items-center">
//                   <svg
//                     className="w-5 h-5 mr-2"
//                     fill="currentColor"
//                     viewBox="0 0 20 20"
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                   <span>{error}</span>
//                 </div>
//               </div>
//             )}

//             {/* Header Section */}
//             <div className="mb-8">
//               <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
//                 <div>
//                   <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
//                     Timesheets
//                   </h1>
//                   <p className="text-gray-600 mt-2">
//                     Track and manage your work hours
//                   </p>
//                 </div>
//                 <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
//                   <div className="relative flex-grow">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="Search tasks..."
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                   </div>
//                   {/* <select
//                     className="block w-full md:w-auto px-4 py-2 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
//                     value={timeRange}
//                     onChange={(e) => setTimeRange(e.target.value)}
//                   >
//                     <option>This Week</option>
//                     <option>Last Week</option>
//                     <option>This Month</option>
//                     <option>Last Month</option>
//                     <option>All Time</option>
//                   </select> */}
//                   <button
//                     onClick={() => navigate("/timesheet")}
//                     className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg shadow-md flex items-center justify-center transition duration-300 whitespace-nowrap"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                       />
//                     </svg>
//                     Add Entry
//                   </button>
//                 </div>
//               </div>

//               {/* Summary Cards */}
//               <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-indigo-100 text-indigo-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Days</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {pagination.total}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-green-100 text-green-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Hours</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {getTotalHours()}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
//                   <div className="flex items-center">
//                     <div className="p-3 rounded-lg bg-purple-100 text-purple-600 mr-4">
//                       <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
//                         />
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-500">Total Tasks</p>
//                       <p className="text-2xl font-semibold text-gray-800">
//                         {timesheets.reduce(
//                           (total, ts) => total + ts.taskDetails.length,
//                           0
//                         )}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Timesheets List */}
//             {timesheets.length === 0 ? (
//               <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-100">
//                 <div className="inline-block bg-indigo-100 p-6 rounded-full mb-4">
//                   <svg
//                     className="w-12 h-12 text-indigo-600"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                 </div>
//                 <h3 className="text-xl font-medium text-gray-700">
//                   No timesheets found
//                 </h3>
//                 <p className="text-gray-500 mt-2 mb-6">
//                   {searchQuery
//                     ? "No tasks match your search criteria"
//                     : "Add your first timesheet entry to get started"}
//                 </p>
//                 <button
//                   onClick={() => navigate("/timesheet")}
//                   className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg shadow-md flex items-center mx-auto"
//                 >
//                   <svg
//                     className="w-4 h-4 mr-2"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 6v6m0 0v6m0-6h6m-6 0H6"
//                     />
//                   </svg>
//                   Add Entry
//                 </button>
//               </div>
//             ) : (
//               <div className="space-y-8">
//                 {Object.entries(groupedTimesheets).map(
//                   ([monthYear, monthTimesheets]) => (
//                     <div
//                       key={monthYear}
//                       className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
//                     >
//                       <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
//                         <h2 className="text-lg font-semibold text-gray-800">
//                           {monthYear}
//                         </h2>
//                       </div>
//                       <div className="divide-y divide-gray-100">
//                         {monthTimesheets.map((timesheet) => (
//                           <div key={timesheet._id} className="p-6">
//                             <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
//                               <div className="flex items-center mb-3 sm:mb-0">
//                                 <div className="bg-indigo-100 p-2 rounded-lg mr-3">
//                                   <span className="text-indigo-600 font-medium">
//                                     {formatDay(timesheet.date)}
//                                   </span>
//                                 </div>
//                                 <div>
//                                   <h3 className="font-medium text-gray-800">
//                                     {formatDate(timesheet.date)}
//                                   </h3>
//                                 </div>
//                               </div>
//                               {/* <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
//                                 <svg
//                                   className="w-4 h-4 inline mr-1"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                   />
//                                 </svg>
//                                 {timesheet.hoursWorked} hours
//                               </div> */}
//                             </div>

//                             <div className="space-y-3">
//                               {timesheet.taskDetails.map((task) => (
//                                 <div
//                                   key={task._id}
//                                   className="bg-gray-50 p-4 rounded-lg"
//                                 >
//                                   <div className="flex justify-between items-start">
//                                     <div className="flex-grow">
//                                       <h4 className="font-medium text-gray-800 flex items-center">
//                                         <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
//                                         {task.taskName}
//                                       </h4>
//                                       <div className="flex items-center mt-2 text-sm text-gray-500">
//                                         <svg
//                                           className="w-4 h-4 mr-1"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                                           />
//                                         </svg>
//                                         <span>{task.duration} hours</span>
//                                       </div>
//                                     </div>
//                                     <div className="flex space-x-2 ml-4">
//                                       <button
//                                         onClick={() =>
//                                           handleUpdateClick(timesheet, task)
//                                         }
//                                         className="text-indigo-600 hover:text-indigo-800 p-1 rounded-full transition"
//                                         title="Edit task"
//                                       >
//                                         <svg
//                                           className="w-5 h-5"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                                           />
//                                         </svg>
//                                       </button>
//                                       <button
//                                         onClick={() =>
//                                           handleDeleteClick(
//                                             timesheet._id,
//                                             task._id
//                                           )
//                                         }
//                                         className="text-red-600 hover:text-red-800 p-1 rounded-full transition"
//                                         title="Delete task"
//                                       >
//                                         <svg
//                                           className="w-5 h-5"
//                                           fill="none"
//                                           stroke="currentColor"
//                                           viewBox="0 0 24 24"
//                                         >
//                                           <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                           />
//                                         </svg>
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )
//                 )}

//                 {/* Pagination Controls */}
//                 <div className="flex justify-center mt-8">
//                   <nav
//                     className="inline-flex rounded-md shadow-sm -space-x-px"
//                     aria-label="Pagination"
//                   >
//                     <button
//                       onClick={() => handlePageChange(pagination.page - 1)}
//                       disabled={pagination.page === 1}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
//                         pagination.page === 1
//                           ? "text-gray-300 cursor-not-allowed"
//                           : "text-gray-500 hover:bg-gray-50"
//                       }`}
//                     >
//                       <span className="sr-only">Previous</span>
//                       <svg
//                         className="h-5 w-5"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                         aria-hidden="true"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </button>

//                     {/* Page numbers */}
//                     {Array.from(
//                       { length: pagination.pages },
//                       (_, i) => i + 1
//                     ).map((pageNum) => (
//                       <button
//                         key={pageNum}
//                         onClick={() => handlePageChange(pageNum)}
//                         className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
//                           pageNum === pagination.page
//                             ? "bg-indigo-600 text-white border-indigo-600"
//                             : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
//                         }`}
//                       >
//                         {pageNum}
//                       </button>
//                     ))}

//                     <button
//                       onClick={() => handlePageChange(pagination.page + 1)}
//                       disabled={pagination.page === pagination.pages}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
//                         pagination.page === pagination.pages
//                           ? "text-gray-300 cursor-not-allowed"
//                           : "text-gray-500 hover:bg-gray-50"
//                       }`}
//                     >
//                       <span className="sr-only">Next</span>
//                       <svg
//                         className="h-5 w-5"
//                         xmlns="http://www.w3.org/2000/svg"
//                         viewBox="0 0 20 20"
//                         fill="currentColor"
//                         aria-hidden="true"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </button>
//                   </nav>
//                 </div>

//                 {/* Page info */}
//                 <div className="text-center text-sm text-gray-500 mt-2">
//                   Showing page {pagination.page} of {pagination.pages} • Total{" "}
//                   {pagination.total} timesheets
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Edit Task Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-xl shadow-xl max-w-md w-full transform transition-all duration-300 ease-in-out">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">Update Task</h3>
//                 <button
//                   onClick={() => setShowModal(false)}
//                   className="text-gray-400 hover:text-gray-500 transition"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Task Name
//                   </label>
//                   <input
//                     type="text"
//                     value={formData.taskName}
//                     onChange={(e) => {
//                       setFormData({ ...formData, taskName: e.target.value });
//                       if (formErrors.taskName) {
//                         setFormErrors({ ...formErrors, taskName: "" });
//                       }
//                     }}
//                     className={`w-full px-3 py-2 border ${
//                       formErrors.taskName ? "border-red-500" : "border-gray-300"
//                     } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500`}
//                   />
//                   {formErrors.taskName && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {formErrors.taskName}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Duration (hours)
//                   </label>
//                   <input
//                     type="number"
//                     value={formData.duration}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
//                         setFormData({ ...formData, duration: value });
//                         if (formErrors.duration) {
//                           setFormErrors({ ...formErrors, duration: "" });
//                         }
//                       }
//                     }}
//                     min="0"
//                     step="0.01"
//                     className={`w-full px-3 py-2 border ${
//                       formErrors.duration ? "border-red-500" : "border-gray-300"
//                     } rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500`}
//                   />
//                   {formErrors.duration && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {formErrors.duration}
//                     </p>
//                   )}
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     onClick={() => setShowModal(false)}
//                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     onClick={handleSaveChanges}
//                     disabled={isSaving}
//                     className={`px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition flex items-center ${
//                       isSaving ? "opacity-70 cursor-not-allowed" : ""
//                     }`}
//                   >
//                     {isSaving ? (
//                       <>
//                         <svg
//                           className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                         Saving...
//                       </>
//                     ) : (
//                       <>
//                         <svg
//                           className="w-4 h-4 mr-2"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
//                           />
//                         </svg>
//                         Save Changes
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Dialog */}
//       {showDeleteDialog && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-xl shadow-xl max-w-md w-full transform transition-all duration-300 ease-in-out">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">
//                   Confirm Delete
//                 </h3>
//                 <button
//                   onClick={() => setShowDeleteDialog(false)}
//                   className="text-gray-400 hover:text-gray-500 transition"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <p className="text-gray-700">
//                   Are you sure you want to delete this task? This action cannot
//                   be undone.
//                 </p>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     onClick={() => setShowDeleteDialog(false)}
//                     className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     onClick={confirmDelete}
//                     className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition flex items-center"
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                       />
//                     </svg>
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </div>
//   );
// };

// export default TimesheetList;


























import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../common/Navbar";
import Sidebar from "../common/Sidebar";
import Footer from "../common/Footer";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Snackbar,
  Button,
  TextField,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Avatar,
  Divider,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Grid,
  Pagination,
  Select,
  MenuItem,
  InputAdornment,
  Chip
} from "@mui/material";
import closee from '../../Assets/closee.png'
import Shrug from '../../Assets/Shrug-rafiki.png'


import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
 

import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  CalendarToday,
  AccessTime,
  Description,
  Search,
  Check,
  ChevronLeft,
  ChevronRight,
  Save,
  Cancel
} from "@mui/icons-material";
import { styled } from "@mui/system";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const StyledCard = styled(Card)({
  marginBottom: "24px",
  borderRadius: "8px",
  boxShadow: "0px 1px 3px rgba(0,0,0,0.2)", // custom shadow
  '&:hover': {
    boxShadow: "0px 4px 6px rgba(0,0,0,0.3)" // hover effect
  }
});


const TaskCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  // backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius
}));

const TimesheetList = () => {
  const navigate = useNavigate();
  const [timesheets, setTimesheets] = useState([]);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ taskName: "", duration: "" });
  const [formErrors, setFormErrors] = useState({ taskName: "", duration: "" });
  const [isSaving, setIsSaving] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState({
    timesheetId: null,
    taskId: null,
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [timeRange, setTimeRange] = useState("This Week");
  const [searchQuery, setSearchQuery] = useState("");

  // Pagination state
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    total: 0,
    pages: 1,
  });

  useEffect(() => {
    const fetchTimesheets = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          setError("No token found. Please log in.");
          return;
        }

        const response = await fetch(
          `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.msg || "Error fetching timesheets");
        }

        const data = await response.json();
        setTimesheets(Array.isArray(data.timesheets) ? data.timesheets : []);
        setPagination({
          ...pagination,
          total: data.total || 0,
          pages: data.pages || 1,
        });
        setError("");
      } catch (err) {
        console.error("Error fetching timesheets:", err);
        setError(err.message || "Error fetching timesheets");
        setTimesheets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTimesheets();
  }, [pagination.page]);

  // Sort and filter timesheets
  const sortedTimesheets = (Array.isArray(timesheets) ? [...timesheets] : [])
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .filter(
      (timesheet) =>
        timesheet.taskDetails &&
        Array.isArray(timesheet.taskDetails) &&
        timesheet.taskDetails.some(
          (task) =>
            task.taskName &&
            task.taskName.toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

  // Group timesheets by month/year
  const groupedTimesheets = sortedTimesheets.reduce((acc, timesheet) => {
    const date = new Date(timesheet.date);
    const monthYear = date.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    });

    if (!acc[monthYear]) {
      acc[monthYear] = [];
    }
    acc[monthYear].push(timesheet);
    return acc;
  }, {});

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  const formatDay = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      weekday: "short",
    });
  };

  const handleUpdateClick = (timesheet, task) => {
    setSelectedTimesheet(timesheet);
    setSelectedTask(task);
    setFormData({ taskName: task.taskName, duration: task.duration });
    setFormErrors({ taskName: "", duration: "" });
    setShowModal(true);
  };

  const handleDeleteClick = (timesheetId, taskId) => {
    setTaskToDelete({ timesheetId, taskId });
    setShowDeleteDialog(true);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { taskName: "", duration: "" };

    if (!formData.taskName.trim()) {
      newErrors.taskName = "Task name is required";
      valid = false;
    }

    if (!formData.duration) {
      newErrors.duration = "Duration is required";
      valid = false;
    } else if (parseFloat(formData.duration) <= 0) {
      newErrors.duration = "Duration must be greater than 0";
      valid = false;
    }

    setFormErrors(newErrors);
    return valid;
  };

  const confirmDelete = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(
        `${BASE_URL}/api/timesheet/delete/${taskToDelete.timesheetId}/task/${taskToDelete.taskId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || "Error deleting task");
      }

      // Refetch timesheets after deletion
      const fetchResponse = await fetch(
        `${BASE_URL}/api/timesheet/logineduser?page=${pagination.page}&limit=${pagination.limit}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!fetchResponse.ok) {
        const errorData = await fetchResponse.json();
        throw new Error(errorData.msg || "Error fetching updated timesheets");
      }

      const data = await fetchResponse.json();
      setTimesheets(data.timesheets);
      setPagination({
        ...pagination,
        total: data.total,
        pages: data.pages,
      });

      setSuccessMessage("Task deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      console.error("Error deleting task:", err);
      setError(err.message || "Error deleting task");
    } finally {
      setShowDeleteDialog(false);
      setTaskToDelete({ timesheetId: null, taskId: null });
    }
  };

  const handleSaveChanges = async () => {
    if (!validateForm()) return;

    try {
      setIsSaving(true);
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(
        `${BASE_URL}/api/timesheet/${selectedTimesheet._id}/tasks/${selectedTask._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || "Error updating task");
      }

      // Manually update the state
      setTimesheets(prevTimesheets =>
        prevTimesheets.map(timesheet => {
          if (timesheet._id === selectedTimesheet._id) {
            const updatedTasks = timesheet.taskDetails.map(task =>
              task._id === selectedTask._id
                ? { ...task, ...formData }
                : task
            );

            const newTotalHours = updatedTasks.reduce(
              (total, task) => total + parseFloat(task.duration || 0),
              0
            );

            return {
              ...timesheet,
              taskDetails: updatedTasks,
              hoursWorked: newTotalHours.toFixed(1)
            };
          }
          return timesheet;
        })
      );

      setSuccessMessage("Task updated successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
      setShowModal(false);
    } catch (err) {
      setError(err.message || "Error updating task");
    } finally {
      setIsSaving(false);
    }
  };

  const getTotalHours = () => {
    return sortedTimesheets.reduce((total, timesheet) => {
      if (!timesheet.taskDetails || !Array.isArray(timesheet.taskDetails)) {
        return total;
      }
      const timesheetHours = timesheet.taskDetails.reduce((sum, task) => {
        return sum + (parseFloat(task.duration) || 0);
      }, 0);
      return total + timesheetHours;
    }, 0).toFixed(1);
  };

  const handlePageChange = (event, newPage) => {
    setPagination({ ...pagination, page: newPage });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="background.default"
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={60} color="primary" />
          <Typography variant="h6" color="primary" mt={2}>
            Loading your timesheets...
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box bgcolor="background.default" minHeight="100vh">
      <Navbar />
      <Box display="flex">
        <Sidebar />

        <Box flex={1} overflow="auto">
          <Box  mx="auto" px={3} py={4}>
            {/* Notification Messages */}
            <Snackbar
              open={!!successMessage}
              autoHideDuration={3000}
              onClose={() => setSuccessMessage("")}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <Alert severity="success" sx={{ width: '100%' }}>
                {successMessage}
              </Alert>
            </Snackbar>

            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            {/* Header Section */}
            <Box mb={4} mt={5}>
              <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }}
                justifyContent="space-between" alignItems={{ md: 'flex-end' }} gap={2}>
                <Box>
                  <Typography variant="h4" fontWeight="bold" color="text.primary">
                    Timesheets List
                  </Typography>
                  <Typography color="text.secondary" mt={1}>
                    Track and manage your work hours
                  </Typography>
                </Box>


              <Box
  display="flex"
  flexDirection={{ xs: 'column', sm: 'row' }}
  alignItems="center"
  gap={1.5}
  width={{ xs: '100%', md: 'auto' }}
>
  {/* Search Field */}
  <TextField
    placeholder="Search tasks..."
    variant="outlined"
    size="small"
    fullWidth
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search style={{ color: '#6b7280', fontSize: 16 }} />
        </InputAdornment>
      ),
      notched: false,
    }}
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    sx={{
      height: '36px',
      '& .MuiInputBase-root': {
        height: '36px',
        borderRadius: '6px',
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb',
        px: 1,
        py: 0,
        fontSize: '14px',
        '&:hover': {
          backgroundColor: '#f9fafb',
        },
      },
      '& fieldset': {
        border: 'none',
      },
    }}
  />

  {/* Add Entry Button */}
  <button
    onClick={() => navigate("/timesheet")}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      marginBottom: "20px",
      padding: '6px 14px',
      backgroundColor: '#ffffff',
      color: '#111827',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: 500,
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
      transition: 'all 0.3s ease',
      height: '36px',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = '#f9fafb';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = '#ffffff';
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="16" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
    Add Entry
  </button>
</Box>



              </Box>

              {/* Summary Cards */}
              <Grid container spacing={2} mt={2}>
                {/* Total Days */}
                <Grid item xs={12} sm={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      bgcolor: "#ffffff",
                    }}
                  >
                    <CardContent
                      sx={{
                        p: 1.8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontSize={14} color="text.secondary">
                          Total Days
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" fontSize={20}>
                          {pagination.total}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: "rgba(33, 150, 243, 0.1)",
                          color: "primary.main",
                          borderRadius: "10px",
                          width: 44,
                          height: 44,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CalendarToday sx={{ fontSize: 24 }} />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Total Hours */}
                <Grid item xs={12} sm={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      bgcolor: "#ffffff",
                    }}
                  >
                    <CardContent
                      sx={{
                        p: 1.8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontSize={14} color="text.secondary">
                          Total Hours
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" fontSize={20}>
                          {getTotalHours()}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: "rgba(102, 187, 106, 0.1)",
                          color: "#2e7d32",
                          borderRadius: "10px",
                          width: 44,
                          height: 44,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <AccessTime sx={{ fontSize: 24 }} />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Total Tasks */}
                <Grid item xs={12} sm={4}>
                  <Card
                    sx={{
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      bgcolor: "#ffffff",
                    }}
                  >
                    <CardContent
                      sx={{
                        p: 1.8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontSize={14} color="text.secondary">
                          Total Tasks
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" fontSize={20}>
                          {timesheets.reduce((total, ts) => total + ts.taskDetails.length, 0)}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: "rgba(156, 39, 176, 0.1)",
                          color: "#9c27b0",
                          borderRadius: "10px",
                          width: 44,
                          height: 44,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Description sx={{ fontSize: 24 }} />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>



            </Box>

            {/* Timesheets List */}
            {timesheets.length === 0 ? (
<Grid
  container
  sx={{
    minHeight: '60vh',
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
    bgcolor: "#ffffff",
    px: { xs: 2, sm: 3 }, // slight horizontal padding on container
  }}
>
  {/* Left Side */}
  <Grid
    item
    xs={12}
    md={6}
    sx={{
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2.5,
      flexDirection: 'column',
    }}
  >
    <Typography
      variant="h6"
      fontWeight="500"
      color="text.primary"
      textAlign="center"
      mb={1.5}
    >
      No timesheets found yet!
    </Typography>

    <Box
      component="img"
      src={Shrug}
      alt="Timesheet Illustration"
      sx={{
        width: '100%',
        maxWidth: 320, // ⬅️ slightly smaller than before
        height: 'auto',
        mt: -3,
      }}
    />
  </Grid>

  {/* Right Side */}
  <Grid
    item
    xs={12}
    md={6}
    sx={{
      backgroundColor: 'background.default',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: { xs: 3, sm: 4 },
    }}
  >
    <Box
      textAlign="center"
      px={3}
      py={4}
      bgcolor="#ffffff"
      borderRadius="16px"
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.08)"
      width="100%"
      maxWidth="380px"
    >
      {/* ✅ Blue square clock icon box */}
      <Box
        sx={{
          width: 56, // ⬅️ medium size
          height: 56,
          mb: 2,
          mx: 'auto',
          bgcolor: '#e3f2fd',
          color: 'primary.main',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AccessTime fontSize="small" />
      </Box>

      <Typography
        variant="h6"
        fontWeight="600"
        color="text.primary"
        gutterBottom
      >
        Add an entry to begin
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        mb={3}
        sx={{ px: 1 }}
      >
        {searchQuery
          ? "No tasks match your search criteria."
          : "Add your first timesheet entry to get started."}
      </Typography>

      {/* ✅ Blue button */}
      <Box mt={1.5}>
        <button
          type="button"
          onClick={() => navigate("/timesheet")}
          style={{
            backgroundColor: "#1E40AF",
            color: "#fff",
            border: "none",
            padding: "9px 18px",
            fontSize: "14.5px",
            fontWeight: "600",
            fontFamily: "'Poppins', sans-serif",
            borderRadius: "8px",
            cursor: "pointer",
            overflow: "hidden",
            position: "relative",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "#1565c0";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.18)";
            const wave = e.currentTarget.querySelector(".hover-wave");
            if (wave) wave.style.left = "100%";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "#1E40AF";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
            const wave = e.currentTarget.querySelector(".hover-wave");
            if (wave) wave.style.left = "-100%";
          }}
        >
          <AddIcon style={{ fontSize: '18px' }} />
          Add Entry
          <span
            className="hover-wave"
            style={{
              position: "absolute",
              top: 0,
              left: "-100%",
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.15)",
              transform: "skewX(-20deg)",
              transition: "left 0.6s ease-in-out",
              pointerEvents: "none",
            }}
          />
        </button>
      </Box>
    </Box>
  </Grid>
</Grid>



            ) : (
              <Box>
                {Object.entries(groupedTimesheets).map(([monthYear, monthTimesheets]) => (
                  <StyledCard
                    key={monthYear}
                    sx={{
                      mb: 4,
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: 'none',
                        border: 'none',
                      },
                    }}
                  >

                    <CardHeader
                      title={monthYear}
                      sx={{
                        bgcolor: 'transparent', // ✅ remove grey background
                        borderBottom: 'none',   // ✅ remove bottom border
                      }}
                      titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                    />

                    <CardContent sx={{ p: 0 }}>
                      {monthTimesheets.map((timesheet) =>
                        timesheet.taskDetails.map((task) => (
                          <Card
                            key={task._id}
                            sx={{
                              m: 2,
                              borderRadius: "8px",
                              bgcolor: "#ffffff",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                              transition: "all 0.3s ease",
                              '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: "0 6px 18px rgba(0, 0, 0, 0.12)",
                                backgroundColor: "#f9f9f9", // Optional light hover background
                              },
                            }}

                          >
                            <CardContent sx={{ pt: 2, px: 3, pb: 2 }}>
                              {/* 📅 Top-left Date */}
                              <Box display="flex" alignItems="center" mb={1}>
                                <Box
                                  sx={{
                                    bgcolor: '#e0e7ff', // light indigo background
                                    color: '#3730a3',   // dark indigo text
                                    fontSize: '0.75rem',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: '6px',
                                    fontWeight: 600,
                                    width: 'fit-content',
                                    marginBottom: "10px",
                                  }}
                                >
                                  {new Date(timesheet.date).toLocaleDateString('en-US', {
                                    weekday: 'short',
                                    month: 'short',
                                    day: 'numeric',
                                  })}
                                </Box>
                              </Box>

                              {/* Task + Duration + Total Hours + Actions */}
                              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                <Box flexGrow={1}>
                                  <Typography
                                    variant="subtitle1"
                                    gutterBottom
                                    sx={{
                                      mb: 1,
                                      fontFamily: '"Outfit", "Inter", "Poppins", "Helvetica Neue", sans-serif',
                                      fontSize: '1rem',
                                      color: '#1E293B',
                                      letterSpacing: '0.3px',
                                      lineHeight: 1.4,
                                      fontWeight: 500,
                                      ml: 1.2,
                                    }}
                                  >
                                    {task.taskName}
                                  </Typography>

                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    flexWrap="wrap"
                                    sx={{ ml: 1 }}
                                  >
                                    <Chip
                                      icon={<AccessTime fontSize="small" />}
                                      label={`${task.duration} hours`}
                                      size="small"
                                      sx={{
                                        borderRadius: '6px',
                                        backgroundColor: '#e8f5e9',
                                        color: '#388e3c',
                                        fontWeight: 500,
                                        fontSize: '0.7rem',
                                        lineHeight: 1,
                                        height: 24,
                                        px: 1.2,
                                        border: 'none',
                                        '& .MuiChip-icon': {
                                          color: '#388e3c',
                                          marginRight: '4px',
                                        },
                                        '& .MuiChip-label': {
                                          padding: 0,
                                        },
                                      }}
                                    />

                                    {/* <Chip
                                      icon={<AccessTime fontSize="small" />}
                                      label={`${timesheet.hoursWorked} Total Hours`}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        borderRadius: '6px',
                                        borderColor: '#e57373',
                                        color: '#e53935',
                                        backgroundColor: '#fff5f5',
                                        fontWeight: 500,
                                        fontSize: '0.7rem',
                                        lineHeight: 1,
                                        height: 24,
                                        px: 1.2,
                                        border: 'none',
                                        '& .MuiChip-icon': {
                                          color: '#e53935',
                                          marginRight: '4px',
                                        },
                                        '& .MuiChip-label': {
                                          padding: 0,
                                        },
                                      }}
                                    /> */}
                                  </Box>
                                </Box>

                                {/* Action buttons */}
                                <Box>
                                  <IconButton
                                    onClick={() => handleUpdateClick(timesheet, task)}
                                    color="primary"
                                    size="small"
                                    title="Edit task"
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    onClick={() => handleDeleteClick(timesheet._id, task._id)}
                                    color="error"
                                    size="small"
                                    title="Delete task"
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Box>
                            </CardContent>

                          </Card>
                        ))
                      )}

                    </CardContent>
                  </StyledCard>
                ))}

                {/* Pagination Controls */}
                <Box display="flex" justifyContent="center" mt={4}>
                  <Pagination
                    count={pagination.pages}
                    page={pagination.page}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                  />
                </Box>

                <Box textAlign="center" mt={2}>
                  <Typography variant="body2" color="text.secondary">
                    Showing page {pagination.page} of {pagination.pages} • Total {pagination.total} timesheets
                  </Typography>
                </Box>
              </Box>

            )}
          </Box>
        </Box>
      </Box>

      {/* Edit Task Modal */}
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px", // rounded corners
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
            bgcolor: "#ffffff", // white background
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: '12px 16px',
            // borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* <Typography variant="h5" fontWeight="500">
            Update Task
          </Typography> */}
          <Box display="flex" justifyContent="space-between" alignItems="center" marginLeft={1}>
            <Typography variant="h6" fontWeight="bold">
              Update Task
            </Typography>

          </Box>

          {/* Uncomment if needed */}
          {/* <button
      onClick={() => setShowModal(false)}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={closee}
        alt="Close"
        style={{
          width: 20,
          height: 20,
          objectFit: 'contain',
        }}
      />
    </button> */}
        </Box>

        {/* Content */}
        <DialogContent sx={{ px: 3, pb: 3 }}>
          <Box
            sx={{
              p: 2,
              backgroundColor: '#f9fafc',
              borderRadius: '12px',
              boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
            }}
          >
            {/* Task Name Label */}
            <Typography
              variant="body2"
              fontWeight={600}
              mb={0.75}
              sx={{
                letterSpacing: '0.3px',
                color: '#1f2937',
                fontSize: '14.5px',
                fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
              }}
            >
              Task Name
            </Typography>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
              multiline
              value={formData.taskName}
              onChange={(e) => {
                setFormData({ ...formData, taskName: e.target.value });
                if (formErrors.taskName) {
                  setFormErrors({ ...formErrors, taskName: '' });
                }
              }}
              error={!!formErrors.taskName}
              helperText={formErrors.taskName}
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  borderColor: '#4B4BFF',
                  boxShadow: '0 0 0 2px rgba(75, 75, 255, 0.2)',
                  height: '100px', // ⬅️ fixed height
                  overflow: 'auto', // ⬅️ scroll if content overflows
                  alignItems: 'flex-start', // align multiline content to top
                },
                '& .MuiOutlinedInput-input': {
                  // height: '100%', // ensure content fills available height
                  border: "none"

                },
                '& .MuiOutlinedInput-notchedOutline': {
                  // borderColor: '#d1d5db',
                  border: "none"

                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  // borderColor: '#4B4BFF',
                  border: "none"

                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  // borderColor: '#4B4BFF',
                  // boxShadow: '0 0 0 2px rgba(75, 75, 255, 0.2)',
                  border: "none"
                },
              }}
              inputProps={{ style: { overflowY: 'auto' } }}
            />


            {/* Duration Label */}
            <Typography
              variant="body2"
              fontWeight={600}
              mb={0.75}
              sx={{
                letterSpacing: '0.3px',
                color: '#1f2937',
                fontSize: '14.5px',
                fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
              }}
            >
              Duration (hours)
            </Typography>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              value={formData.duration}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                  setFormData({ ...formData, duration: value });
                  if (formErrors.duration) {
                    setFormErrors({ ...formErrors, duration: '' });
                  }
                }
              }}
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              error={!!formErrors.duration}
              helperText={formErrors.duration}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  borderColor: '#4B4BFF',
                  boxShadow: '0 0 0 2px rgba(75, 75, 255, 0.2)',
                },
                '& .MuiOutlinedInput-input': {
                  border: 'none',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
              }}
            />

          </Box>

        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ px: 3, pb: 2 }}>
          {/* Cancel Button */}
          <button
            onClick={() => setShowModal(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#111827',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              height: '44px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f9fafb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffffff';
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#111827"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
            Cancel
          </button>


          {/* Save Changes Button */}
          <button
            onClick={handleSaveChanges}
            disabled={isSaving}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px', // match Cancel button
              fontSize: '16px',
              fontWeight: 500, // match Cancel button weight
              color: '#ffffff',
              backgroundColor: '#4B4BFF',
              border: 'none',
              borderRadius: '12px',
              cursor: isSaving ? 'not-allowed' : 'pointer',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              opacity: isSaving ? 0.7 : 1,
              height: '44px', // ensures consistent height
            }}
            onMouseEnter={(e) => {
              if (!isSaving) e.currentTarget.style.backgroundColor = '#3737db';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#4B4BFF';
            }}
          >
            {isSaving ? (
              <>
                <div
                  style={{
                    width: 20,
                    height: 20,
                    border: '3px solid white',
                    borderTop: '3px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                  }}
                />
                Saving...
              </>
            ) : (
              <>
                Save Changes
                <span style={{ fontSize: '20px' }}>→</span>
              </>
            )}
          </button>

          {/* Spinner animation */}
          <style>
            {`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `}
          </style>


          {/* Spinner keyframes */}
          <style>
            {`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `}
          </style>

        </DialogActions>
      </Dialog>




      {/* Delete Confirmation Dialog */}
      <Dialog open={showDeleteDialog} onClose={() => setShowDeleteDialog(false)} maxWidth="sm" fullWidth PaperProps={{
        sx: {
          borderRadius: "16px", // rounded corners
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
          bgcolor: "#ffffff", // white background
        },
      }}>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              Confirm Delete
            </Typography>

          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" my={2} sx={{
            p: 2,
            backgroundColor: '#f9fafc',
            borderRadius: '12px',
            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
          }}>
            Are you sure you want to delete this task? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={() => setShowDeleteDialog(false)}
            startIcon={
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#111827"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            }
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#111827',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
              textTransform: 'none',
              height: '44px',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: '#f9fafb',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
              },
            }}
          >
            Cancel
          </Button>


          <Button
            onClick={confirmDelete}
            startIcon={<DeleteIcon />}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 20px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#ffffff',
              backgroundColor: '#dc2626', // Tailwind red-600
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              textTransform: 'none',
              height: '44px',
              '&:hover': {
                backgroundColor: '#b91c1c', // red-700
              },
              '&.Mui-disabled': {
                opacity: 0.7,
                cursor: 'not-allowed',
                backgroundColor: '#dc2626',
              },
            }}
          >
            Delete
          </Button>

        </DialogActions>
      </Dialog>

      <Footer />
    </Box>
  );
};

export default TimesheetList;